import { useEffect, useState } from "react";
import AuthzRolesDomain from "domainActions/roles/AuthzRolesDomain";
function useRoles() {
  const [paginatedRoles, setPaginatedRoles] = useState();
  useEffect(() => {
    const getUnlimited = { page: 1, perPage: 0, query: "" };
    AuthzRolesDomain.loadRolesPaginated(getUnlimited).then(setPaginatedRoles);
  }, []);
  if (!paginatedRoles) {
    return {
      isLoading: true,
      roles: []
    };
  }
  const roles = paginatedRoles.list.toArray();
  return {
    isLoading: false,
    roles
  };
}
export default useRoles;
